import { render } from "./VicIcon.vue?vue&type=template&id=3f6cb786&scoped=true"
import script from "./VicIcon.vue?vue&type=script&lang=js"
export * from "./VicIcon.vue?vue&type=script&lang=js"

import "./VicIcon.vue?vue&type=style&index=0&id=3f6cb786&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6cb786"]])

export default __exports__